module.exports = __webpack_public_path__ + "media/images/icon_nav_amount_black-943373bfb23d61ef5ab5b957cf468fb0.svg";